export default "__VITE_PUBLIC_ASSET__4103122f__"